import { RouteLocationNode } from '../../../../../common/model/route-location-node';

export const RouteLocations = {
  Home: new RouteLocationNode('', {
    queryParams: {
      Stay: 'stay',
    },
  }),

  Dashboard: new RouteLocationNode('dashboard', {
    children: {
      Home: new RouteLocationNode(''),
      GameEntities: new RouteLocationNode('entities', {
        children: {
          GameEntityList: new RouteLocationNode('', {
            queryParams: {
              gameEntityType: 'type',
              viewEntity: 'view',
            },
          }),
          GameEntityEditor: new RouteLocationNode(':gameEntityId/edit', {
            params: {
              gameEntityId: 'gameEntityId',
            },
            queryParams: {
              type: 'type',
              template: 'template',
            },
          }),
        },
      }),
      Campaigns: new RouteLocationNode('campaigns', {
        children: {
          CampaignList: new RouteLocationNode(''),
          CampaignPage: new RouteLocationNode(':campaignId', {
            params: {
              campaignId: 'campaignId',
            },
          }),
          CampaignSessionPage: new RouteLocationNode(':campaignId/sessions/:campaignSessionId', {
            params: {
              campaignId: 'campaignId',
              campaignSessionId: 'campaignSessionId',
            },
          }),
          JoinCampaign: new RouteLocationNode('join-campaign', {
            queryParams: {
              token: 'token',
              campaign: 'campaign',
            },
          }),
        },
      }),
    },
  }),

  Login: new RouteLocationNode('login', {
    queryParams: {
      register: 'register',
    },
  }),

  TermsAndConditions: new RouteLocationNode('terms'),
  PrivacyPolicy: new RouteLocationNode('privacy'),

  NotFound: new RouteLocationNode('not-found'),
};
